import useComputed from '@/hooks/use-computed'
import useSchemaProperties from '@/hooks/use-schema-properties'
import api from '@/services/api/admin/dataElements.js'
import titleCase from '@/utils/title-case'
import { immerable } from "immer"
import { useState } from 'react'
class DataElement {

	[immerable] = true

	constructor(params) {
		this.id = params.id
		this.name = params.name
		this.querySchema = params.querySchema
		this.schema = params.schema
		this.requiredFields = params.requiredFields
		this.optionalFields = params.optionalFields
		this.attachmentFields = params.attachmentFields

		this.$selected = false
	}
}

const useDataElements = (_dataElementId) => {

	const [items, setItems] = useComputed([])

	const { getRequiredFields, getOptionalFields, getAttachments } = useSchemaProperties();

	const [metaDataElement, setMetaDataElement] = useState(null)

	const [currentItem, setCurrentItem] = useState(null)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState()

	async function fetch(parameter) {

		setLoading(true)

		const params = parameter || "";

		const [errResponse, dataResponse] = await api.index({
			params
		})

		setLoading(false)

		if (errResponse) {
			return setError(errResponse)
		}

		const { meta } = dataResponse

		if (!Array.isArray(dataResponse)) {
			return setError('Data Elements is not an array')
		}

		const serializedData = dataResponse.map(entry => serialize(entry))
		const newItems = serializedData.map(entry => new DataElement(entry))

		setMetaDataElement(meta)
		return setItems(newItems)
	}

	async function find(parameter) {

		setLoading(true)

		const params = parameter || "";

		const [errResponse, dataResponse] = await api.index({
			params
		})

		setLoading(false)

		if (errResponse) {
			return setError(errResponse)
		}

		if (!Array.isArray(dataResponse)) {
			return setError('Data Elements is not an array')
		}

		const serializedData = dataResponse.map(entry => serialize(entry))
		return serializedData.map(entry => new DataElement(entry))


	}

	function serialize(entry) {
		const requiredFields = getRequiredFields(JSON.parse(entry.elementSchema))
		const optionalFields  = getOptionalFields(JSON.parse(entry.elementSchema))
		const attachmentFields = getAttachments(JSON.parse(entry.elementSchema))
		return {
			id: entry.dataElementId,
			name: entry.elementName,
			schema: JSON.parse(entry.elementSchema),
			requiredFields: requiredFields,
			optionalFields: optionalFields,
			attachmentFields: attachmentFields,
			type: titleCase(entry.type),
		}
	}

	function view(id) {
		const newCurrentItem = items.find(item => item.id === id)
		setCurrentItem(newCurrentItem)
	}

	return {
		error,
		fetch,
		items,
		currentItem,
		setCurrentItem,
		loading,
		setItems,
		view,
		find,
		metaDataElement
	}

}

export default useDataElements
